var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_65078",
    "data-name": "Group 65078",
    transform: "translate(-1437 -165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_65077",
    "data-name": "Group 65077",
    transform: "translate(9 -17)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Youtube",
    transform: "translate(1427.997 181.914)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_32",
    "data-name": "Ellipse 32",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(0.003 0.086)",
    fill: "#f4f4f4",
    opacity: 0.996
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Server",
    transform: "translate(1450 178)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93361",
    "data-name": "Path 93361",
    d: "M14.884,9.014h-7.5a.37.37,0,0,0,0,.74h7.5a.37.37,0,0,0,0-.74Z",
    transform: "translate(-4.384 -5.634)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4111",
    "data-name": "Ellipse 4111",
    cx: 1.308,
    cy: 1.308,
    r: 1.308,
    transform: "translate(18.315 2.616)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93362",
    "data-name": "Path 93362",
    d: "M22.5,0H1.5A1.5,1.5,0,0,0,0,1.5V6A1.5,1.5,0,0,0,1.5,7.5h21A1.5,1.5,0,0,0,24,6V1.5A1.5,1.5,0,0,0,22.5,0Zm.75,6a.751.751,0,0,1-.75.75H1.5A.751.751,0,0,1,.75,6V1.5A.751.751,0,0,1,1.5.75h21a.751.751,0,0,1,.75.75Z",
    transform: "translate(0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93363",
    "data-name": "Path 93363",
    d: "M14.884,31.014h-7.5a.37.37,0,0,0,0,.74h7.5a.37.37,0,0,0,0-.74Z",
    transform: "translate(-4.384 -19.383)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4112",
    "data-name": "Ellipse 4112",
    cx: 1.308,
    cy: 1.308,
    r: 1.308,
    transform: "translate(18.315 10.466)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93364",
    "data-name": "Path 93364",
    d: "M22.5,22H1.5A1.5,1.5,0,0,0,0,23.5V28a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,28V23.5A1.5,1.5,0,0,0,22.5,22Zm.75,6a.751.751,0,0,1-.75.75H1.5A.751.751,0,0,1,.75,28V23.5a.751.751,0,0,1,.75-.75h21a.751.751,0,0,1,.75.75Z",
    transform: "translate(0 -13.75)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93365",
    "data-name": "Path 93365",
    d: "M14.884,53.014h-7.5a.37.37,0,0,0,0,.74h7.5a.37.37,0,0,0,0-.74Z",
    transform: "translate(-4.384 -33.133)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4113",
    "data-name": "Ellipse 4113",
    cx: 1.308,
    cy: 1.308,
    r: 1.308,
    transform: "translate(18.315 19.187)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93366",
    "data-name": "Path 93366",
    d: "M22.5,44H1.5A1.5,1.5,0,0,0,0,45.5V50a1.5,1.5,0,0,0,1.5,1.5h21A1.5,1.5,0,0,0,24,50V45.5A1.5,1.5,0,0,0,22.5,44Zm.75,6a.751.751,0,0,1-.75.75H1.5A.751.751,0,0,1,.75,50V45.5a.751.751,0,0,1,.75-.75h21a.751.751,0,0,1,.75.75Z",
    transform: "translate(0 -27.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerIcon);
export default __webpack_public_path__ + "static/media/server-icon.587e158f.svg";
export { ForwardRef as ReactComponent };